<div class="screen-blinding" *ngIf="showBlinding">
  <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />

  <img src="../../../assets/images/icons/mobile-off.png" alt="mobile-off" width="90" class="mt-4 mb-3">

  <h1 class="mb-1">{{ 'MISC.SORRY' | translate}}</h1>
  <h4>{{ 'MISC.MOBILE_NOT_SUPPORTED' | translate }}</h4>
  <h4>{{ 'MISC.ONLY_USE_VIA_IPAD_DESKTOP' | translate }}</h4>
</div>